module.exports = __webpack_public_path__ + "img/Origine_Espagne.b9b81f03.png";